import React, {ReactElement} from 'react';
import Styles from './CopyRight_SA.module.scss'
import classnames from 'classnames';

interface SocialProps {
  content: string,
  image?: ReactElement
}
const CopyRightSection: React.FC<SocialProps> = (props: SocialProps) => {
  return (
    <div className={classnames(Styles.backGround, Styles.height, "row justify-content-center")}>
      <div className = "mx-auto">
          <div className = "col-lg-12 text-center" >
            <span className="pr-2">{props.image}</span>
            <sub className="normal">{props.content}</sub>
          </div>
        </div>
    </div>
  );
};

export default CopyRightSection;